import { Box, styled } from '@mui/material';

export const RootContainer = styled(Box)`
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  @media (max-width: 767px) {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
`;

export const ContentContainer = styled(Box)`
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
`;
